import { render, staticRenderFns } from "./AccountManagement.vue?vue&type=template&id=24d6702a&scoped=true"
import script from "./AccountManagement.vue?vue&type=script&lang=js"
export * from "./AccountManagement.vue?vue&type=script&lang=js"
import style0 from "./AccountManagement.vue?vue&type=style&index=0&id=24d6702a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d6702a",
  null
  
)

export default component.exports